import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import { UserStatusType } from "~~/package/mapper/user/model/UserStatusType";

export class ProSkillManagerActionUserInfoModel extends Model {
  constructor(
    public nickName: string | null = null,
    public profileImageUrl: string | null = null,
    public email: string | null = null,
    public userStatus: UserStatusType = UserStatusType.NORMAL
  ) {
    super();
  }

  public static create(model: Partial<ProSkillManagerActionUserInfoModel>): ProSkillManagerActionUserInfoModel {
    return createModel<ProSkillManagerActionUserInfoModel>(ProSkillManagerActionUserInfoModel, {
      ...model
    });
  }
}
